import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const NewHero = () => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const heroRef = useRef(null);
    const videoRef = useRef(null);
    const glowRef = useRef(null);

    // Intersection Observer for entrance animations
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.3 }
        );

        if (heroRef.current) {
            observer.observe(heroRef.current);
        }

        return () => observer.disconnect();
    }, []);

    // Video loading and playback
    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.play().catch(() => {
                // Autoplay was prevented, we'll handle it silently
            });

            const handleVideoLoad = () => {
                setIsVideoLoaded(true);
            };

            videoRef.current.addEventListener('loadeddata', handleVideoLoad);

            return () => {
                videoRef.current?.removeEventListener('loadeddata', handleVideoLoad);
            };
        }
    }, []);

    // Parallax mouse effect for glass button
    const handleMouseMove = (e) => {
        if (!heroRef.current) return;

        const rect = heroRef.current.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        setMousePosition({ x, y });

        if (glowRef.current) {
            glowRef.current.style.background = `radial-gradient(circle at ${x}% ${y}%, rgba(255, 215, 0, 0.15), transparent 50%)`;
        }
    };

    const handleButtonClick = () => {
        navigate('/contact');
    };

    return (
        <div
            ref={heroRef}
            className="new-hero"
            onMouseMove={handleMouseMove}
        >
            {/* Video Background */}
            <div className="new-hero-video-wrapper">
                <video
                    ref={videoRef}
                    autoPlay
                    muted
                    loop
                    playsInline
                    className={`new-hero-video ${isVideoLoaded ? 'loaded' : ''}`}
                >
                    <source src="/bg-video.mp4" type="video/mp4" />
                    {/* Fallback for browsers that don't support video */}
                    <div className="new-hero-fallback"></div>
                </video>
                <div className="new-hero-overlay"></div>
            </div>

            {/* animatedd Particles */}
            <div className="new-hero-particles">
                {[...Array(20)].map((_, i) => (
                    <div
                        key={i}
                        className="new-hero-particle"

                    />
                ))}
            </div>

            {/* Main Content */}
            <div className="new-hero-content">
                <div className="new-hero-container">


                    {/* Main Title with Split Text Animation */}
                    <h1 className={`new-hero-title ${isVisible ? 'animated' : ''}`}>
                        <span className="new-hero-title-line">
                            <span className="new-hero-title-word">Stop Wasting Money on Ads that
                            </span>

                        </span>
                        <span className="new-hero-title-line">
                            <span className="new-hero-title-word gradient-text-hero">Don't Convert</span>
                        </span>

                    </h1>

                    {/* Description */}
                    <p className={`new-hero-description ${isVisible ? 'animated' : ''}`}>
                        Built for businesses that want more than clicks
                        we focus on revenue,not vanity metrics
                    </p>


                    <div className='text-center'>
                        {/* CTA Buttons */}
                        <div className="flex-align-items-center">
                            <Link to='contact' className={`mx-2 new-hero-cta ${isVisible ? 'animated' : ''}`}>
                                <button
                                    className="d-flex new-hero-btn new-hero-btn-primary"
                                >
                                    <span className="d-block new-hero-btn-text">Book a Free Audit</span>
                                    <span className="new-hero-btn-icon">→</span>
                                    <div ref={glowRef} className="new-hero-btn-glow"></div>
                                </button>



                            </Link>
                            <Link to='services' className={`new-hero-cta ${isVisible ? 'animated' : ''}`}>
                                <button
                                    to='/services'
                                    className="d-flex new-hero-btn new-hero-btn-primary"
                                >
                                    <span className="btn-text  position-relative z-2">Explore Services
                                    </span>
                                    <span className="font-weight-bold  ms-3">→</span>
                                    <div ref={glowRef} className="new-hero-btn-glow"></div>
                                </button>



                            </Link>
                        </div>
                    </div>

                    {/* Trust Badges */}
                    <div className={`new-hero-trust ${isVisible ? 'animated' : ''}`}>
                        <div className="new-hero-trust-logos">
                            <div className="new-hero-trust-logo">◉ UK-Based  </div>
                            <div className="new-hero-trust-logo">◉ Data-Led Strategies</div>
                            <div className="new-hero-trust-logo">◉ Transparent Reporting</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewHero;